import { render, staticRenderFns } from "./FFFTable.vue?vue&type=template&id=7896f160&"
import script from "./FFFTable.vue?vue&type=script&lang=js&"
export * from "./FFFTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports